import { Key, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';

import { DropDownProps } from './Dropdown';

export const useDropdown = (props: DropDownProps) => {
  const selectedIndex = props.selectedIndex;
  const [selected, setSelected] = useState(new Set<Key>(selectedIndex !== undefined ? [selectedIndex.toString()] : []));

  const [selectedIndexInitial, setSelectedIndexInitial] = useState(selectedIndex);
  if (selectedIndex !== undefined && selectedIndex !== selectedIndexInitial) {
    setSelectedIndexInitial(selectedIndex);
    setSelected(new Set<Key>(selectedIndex !== undefined ? [selectedIndex.toString()] : undefined));
  }

  useEffect(() => {
    if (selectedIndex !== undefined) {
      setSelected(new Set<Key>(selectedIndex !== undefined ? [selectedIndex.toString()] : undefined));
    } else {
      setSelected(new Set<Key>(undefined));
    }
  }, [selectedIndex]);

  const buttonRef = useRef<HTMLElement>();
  const [buttonWidth, setButtonWidth] = useState(0);

  useLayoutEffect(() => {
    function updateSize() {
      setButtonWidth(buttonRef?.current?.offsetWidth);
    }

    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const selectedValue = useMemo(
    () =>
      Array.from(selected)
        .map((item) => props.items[item]?.text)
        .join(', '),
    [selected],
  );

  const selectedDescription = useMemo(
    () =>
      Array.from(selected)
        .map((item) => props.items[item]?.description)
        .join(', '),
    [selected],
  );

  const selectedIcon = useMemo(() => {
    if (props.multiselect) return undefined;

    return props.items[Array.from(selected)[0]]?.icon;
  }, [selected]);

  const selectedRightIcon = useMemo(() => {
    if (props.multiselect) return undefined;

    return props.items[Array.from(selected)[0]]?.rightIcon;
  }, [selected]);

  const disabledKeysLocal = useMemo(() => {
    return props.disabledKeys?.map((key) =>
      props.items.findIndex((item) => (item.key || item.text) === key).toString(),
    );
  }, [props.disabledKeys]);

  return {
    selected,
    setSelected,
    selectedValue,
    selectedDescription,
    selectedIcon,
    buttonWidth,
    buttonRef,
    disabledKeysLocal,
    selectedRightIcon,
  };
};

export default useDropdown;
